import api from './api';

/**
 * Course Service
 * Handles all course-related API calls
 * Backend populates instructor on GET/PUT
 */

const courseService = {
  /**
   * Get all courses (with instructor populated)
   * @returns {Promise<Array>} - List of courses
   */
  getAllCourses: async () => {
    try {
      const response = await api.get('/courses');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Get course by ID (with instructor populated)
   * @param {string} id - Course ID
   * @returns {Promise<Object>} - Course object
   */
  getCourseById: async (id) => {
    try {
      const response = await api.get(`/courses/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Create new course
   * @param {Object} courseData - Course data (e.g. name, description, instructor ID)
   * @returns {Promise<Object>} - Created course object
   */
  createCourse: async (courseData) => {
    try {
      const response = await api.post('/courses', courseData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Update course (returns course with instructor populated)
   * @param {string} id - Course ID
   * @param {Object} courseData - Course data to update
   * @returns {Promise<Object>} - Updated course object
   */
  updateCourse: async (id, courseData) => {
    try {
      const response = await api.put(`/courses/${id}`, courseData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Delete course
   * @param {string} id - Course ID
   * @returns {Promise<Object>} - Deletion confirmation with deleted course
   */
  deleteCourse: async (id) => {
    try {
      const response = await api.delete(`/courses/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default courseService;
